export const getLqzyParams = () => {
    const params = new URLSearchParams(window.location.search);
    const affiliateCode = params.get("aff");
  
    let query = "";
    if (affiliateCode) {
      query = `?aff=${affiliateCode}`;
    }
    return query;
  };
  